import { cn } from '@repo/ui/lib/utils';

interface TagsProps {
  text: string;
  onClick?: () => void;
  rounder?: boolean;
  size?: "sm" | "md" | "lg";
}
function Tags({ text, onClick, rounder, size = "md" }: TagsProps) {
  const sizeClasses = {
    sm: "text-sm px-2 py-1",
    md: "text-base px-3 py-2",
    lg: "text-lg px-4 py-2.5",
  };

  return (
    <span
      className={cn(
        "inline-flex text-green-500",
        sizeClasses[size],
        rounder ? "bg-yellow rounded-3xl text-green" : "rounded-md bg-green-100"
      )}
      onClick={onClick}
      aria-hidden="true"
    >
      {text}
    </span>
  );
}

export default Tags;
